import { Type } from 'class-transformer';
import { IsOptional, ValidateNested } from 'class-validator';
import { IsMongoIdObject } from '../../../decorators/is-mongo-object-id.decorator';
import { TokenVaultId } from '../../../types';
import { UserRegistrationCreatedByPopulateDto } from '../../user-registration';
import { UserCreatedByPopulateDto } from '../../users';

export class SmsContextDto {
  @ValidateNested()
  @Type(() => UserCreatedByPopulateDto)
  @IsOptional()
  user?: UserCreatedByPopulateDto;

  @ValidateNested()
  @Type(() => UserRegistrationCreatedByPopulateDto)
  @IsOptional()
  userRegistration?: UserRegistrationCreatedByPopulateDto;

  @IsMongoIdObject()
  @IsOptional()
  tokenVault?: TokenVaultId;
}
